import React from 'react';
import Modal from '../../../../../../components/Modal';
import Table from '../../../../../../components/table/Table';
import columns from './columns';
import './AccountUserDetailLikeProductLogModal.scss';

const AccountUserDetailLikeProductLogModalView = (props) => {
  const { isOpen = true, likeProductLogList, closeModal, filterOption, sortOption, pagination, getList } = props;
  const { totalCnt, logList, mainProductCategorySelectList } = likeProductLogList;

  return (
    <Modal
      title="유저 상품 좋아요 타임라인 리스트"
      isOpen={isOpen}
      width={1300}
      height={600}
      isFooter={true}
      onOk={() => closeModal()}
      onClose={() => closeModal()}
    >
      <div className="account-user-detail-like-product-timeline-modal">
        <Table
          data={logList}
          totalCnt={totalCnt}
          isStriped={true}
          scroll={{ x: true }}
          emptyText="요청하신 검색 필터로 검색된 좋아요한 상품 타임라인 리스트가 없습니다."
          showPagination
          filterOption={filterOption}
          sortOption={sortOption}
          pagination={pagination}
          getList={getList}
          columns={(utils) =>
            columns({
              ...utils,
              mainProductCategorySelectList,
            })
          }
        />
      </div>
    </Modal>
  );
};

export default AccountUserDetailLikeProductLogModalView;
